import CheckListEmp from "../../components/employeeDetails/CheckListEmp";
import Dependants from "../../components/employeeDetails/Dependants";
import Docs from "../../components/employeeDetails/Docs";
import Education from "../../components/employeeDetails/Education";
import Emergency from "../../components/employeeDetails/Emergency";
import GeneralInfo from "../../components/employeeDetails/GeneralInfo";
import Health from "../../components/employeeDetails/Health";
import JobHistory from "../../components/employeeDetails/JobHistory";
import FormDocuments from "../maintenance/documents/DocumentsChecklist";
import ActivoFijo from "./ActivoFijo";
import Classification from "./Classification";
import CollegeDegree from "./CollegeDegree";
import CrudAreas from "./CrudAreas";
import DashboardIndPlazContJefes from "./DashboardIndPlazContJefes";
import Diagnosis from "./Diagnosis";
import Division from "./Division";
import EmployeedTimes from "./EmployeedTimes";
import Employees from "./Employees";
import ExcelMassiveUpload from "./ExcelMassiveUpload";
import DashboardPositionH from "./HeadcountPositionDashboard";
import Institute from "./Institute";
import JobPosition from "./JobPosition";
import JobpositionRelated from "./JobpositionRelated";
import MarcajeCTM from "./MarcajeCTM";
import OrgsForEmployees from "./OrgsForEmployees";
import PersonalDivision from "./PersonalDivision";
import SessionNotification from "./SessionNotification";
import Specialization from "./Specialization";
import GestionTiempos from "./gestionTiempos";
import EmployeeDetail from "./staffInventory/EmployeeDetail";
import EmployeeTab from "./staffInventory/EmployeeTab";
import DesarrolloPersonal from "./DesarrolloPersonal";
import AuroraDivision from "./AuroraDivision";
import CompanyResponsibles from "./CompanyResponsibles";
import GestionTiemposRefanic from "./GestionTiemposRefanic";

const HeadcountRouter = [
  {
    type: "private",
    path: "/relacion-posicion",
    roles: ["administrador"],
    component: JobpositionRelated,
    exact: true,
  },
  {
    type: "private",
    path: "/excel-carga-masiva",
    roles: ["administrador"],
    component: ExcelMassiveUpload,
    exact: true,
  },
  {
    type: "private",
    path: "/mantenimiento-documentacion/:type",
    roles: ["administrador"],
    component: FormDocuments,
    exact: true,
  },
  {
    type: "private",
    path: "/detalle-empleado/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: EmployeeDetail,
    exact: true,
  },
  {
    type: "private",
    path: "/ficha-empleado/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: EmployeeTab,
    exact: true,
  },
  {
    type: "private",
    path: "/general-info-empleado/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: GeneralInfo,
    exact: true,
  },
  {
    type: "private",
    path: "/empleado-familiares/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: Dependants,
    exact: true,
  },
  {
    type: "private",
    path: "/empleado-contactos-emergencia/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: Emergency,
    exact: true,
  },
  {
    type: "private",
    path: "/empleado-salud/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: Health,
    exact: true,
  },
  {
    type: "private",
    path: "/empleado-docs/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: Docs,
    exact: true,
  },
  {
    type: "private",
    path: "/empleado-educacion/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: Education,
    exact: true,
  },
  {
    type: "private",
    path: "/empleado-historial-laboral/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: JobHistory,
    exact: true,
  },
  {
    type: "private",
    path: "/empleado-tiempos/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: EmployeedTimes,
    exact: true,
  },
  {
    type: "private",
    path: "/usuario-documentos/:id/:type",
    roles: [
      "administrador",
      "jefe",
      "empleado",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: CheckListEmp,
    exact: true,
  },
  {
    type: "private",
    // path: "/dashboard-plazas-cont-admin",
    path: "/tablero-headCount",
    roles: ["administrador", "alta_direccion", "Responsable_Headcount"],
    component: DashboardIndPlazContJefes,
    exact: true,
  },
  {
    type: "private",
    // path: "/dashboard-plazas-y-contrataciones-jefes",
    path: "/indicador-headcount",
    roles: ["jefe", "administrador", "Responsable_Headcount"],
    component: DashboardPositionH,
    exact: true,
  },
  {
    type: "private",
    path: "/gestión-de-tiempos",
    roles: ["administrador", "jefe", "Responsable_Headcount"],
    component: GestionTiempos,
    exact: true,
  },
   {
    type: "private",
    path: "/gestión-de-tiempos-refanic",
    roles: ["administrador", "jefe", "Responsable_Headcount"],
    component: GestionTiemposRefanic,
    exact: true,
  },
  {
    type: "private",
    path: "/notificaciones-de-no-ingreso",
    roles: ["administrador"],
    component: SessionNotification,
    exact: true,
  },
  {
    type: "private",
    path: "/cargos/:type",
    roles: ["administrador"],
    component: JobPosition,
    exact: true,
  },
  {
    type: "private",
    path: "/empresas-filtro-empleados/:type",
    roles: ["administrador"],
    component: OrgsForEmployees,
    exact: true,
  },
  {
    type: "private",
    path: "/empleados/:id/:name/:oType/:searchtype/:filter/:searchFilter",
    roles: ["administrador"],
    component: Employees,
    exact: true,
  },
  {
    type: "private",
    path: "/clasificación/:type",
    roles: ["administrador"],
    component: Classification,
    exact: true,
  },
  {
    type: "private",
    path: "/institutos/:type",
    roles: ["administrador"],
    component: Institute,
    exact: true,
  },
  {
    type: "private",
    path: "/especializacion/:type",
    roles: ["administrador"],
    component: Specialization,
    exact: true,
  },
  {
    type: "private",
    path: "/titulo/:type",
    roles: ["administrador"],
    component: CollegeDegree,
    exact: true,
  },
  {
    type: "private",
    path: "/division/:type",
    roles: ["administrador"],
    component: Division,
    exact: true,
  },
  {
    type: "private",
    path: "/division-personal/:type",
    roles: ["administrador"],
    component: PersonalDivision,
    exact: true,
  },
  {
    type: "private",
    path: "/diagnosticos/:type",
    roles: ["administrador"],
    component: Diagnosis,
    exact: true,
  },
  {
    type: "private",
    path: "/activos-fijos/:id/:type",
    roles: [
      "administrador",
      "empleado",
      "Responsable_Headcount",
      "Responsable_Capacitacion",
      "Responsable_Evaluacion",
      "Responsable_Seleccion_Contratacion",
      "Responsable_Descriptores_Perfiles",
      "Responsable_Sanciones",
      "Encargado_Sanciones",
      "Responsable_OffBoarding",
      "Responsable_OnBoarding",
      "responsable",
      "alta_direccion",
      "jefe",
    ],
    component: ActivoFijo,
    exact: true,
  },
  {
    type: "private",
    path: "/marcaje-ctm",
    roles: ["administrador", "jefe", "Responsable_Headcount"],
    component: MarcajeCTM,
    exact: true,
  },
  {
    type: "private",
    path: "/desarrollo-personal",
    roles: ["administrador", "jefe", "alta_direccion", "Responsable_Headcount"],
    component: DesarrolloPersonal,
    exact: true,
  },
  {
    type: "private",
    path: "/unidad/:type",
    roles: ["administrador"],
    component: CrudAreas,
    exact: true,
  },
  {
    type: "private",
    path: "/aurora-division/:type",
    roles: ["administrador"],
    component: AuroraDivision,
    exact: true,
  },
  {
    type: "private",
    path: "/usuario-empresa/:type",
    roles: ["administrador", "Responsable_Rol_Empresa"],
    component: CompanyResponsibles,
    exact: true,
  },
  
];

export default HeadcountRouter;
